import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import { resetUserMood } from '../../redux/member';
import { RootState } from '../../redux/store';
import { deleteMemberMood } from '../../services/memberService';
import Mood from './components/Mood'

const SelectMood = ({ setMood, next, prev }: any) => {
    const member = useSelector((state: RootState) => state.member);
    const moods = useSelector((state: RootState) => state.mood);
    let history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    const deleteMood = async () => {
        await deleteMemberMood(member.memberCode);
        dispatch(resetUserMood({ moodText: null, moodImage: null }));
        close();
    }

    useEffect(() => {
    }, [moods])

    const close = () => {
        history.goBack();
    };

    const onSelect = (id: number) => {
        const mood = moods.filter(x => x.moodId === id)[0];
        setMood(mood);
        next();
    };

    return (
        <>
            <div className="content_sec red wf-section">
                <div className="mood_content">
                    <a onClick={close} href="#" className="mood_close w-inline-block">
                        <img src="/assets/images/ic_back.svg" loading="lazy" alt="" />
                    </a>
                    {/* <div>היי {member.nickName}, טוב שבאת!</div> */}
                    <h2 className="signup_title mood">יש הרבה דברים שאפשר לעשות ביחד, מה הכי מתחשק לך היום?</h2>

                    <ul className="mood_list w-list-unstyled">
                        {moods.map((mood, index) => {
                            return <Mood key={index} onSelect={() => onSelect(mood.moodId)} moodName={mood.moodText} moodImage={mood.moodImage} />
                        })}
                    </ul>

                    <div onClick={deleteMood} className="clear_link mood" style={{ cursor: "pointer" }}>
                        לא הפעם
                    </div>

                    {/* <a onClick={close} href="#" className="clear_link mood">
                        סגירה
                    </a> */}
                </div>
            </div>

        </>
    )


}

export default SelectMood;

function dispatch(arg0: { type: string; data: any; }) {
    throw new Error('Function not implemented.');
}
